import { SvgIconProps } from "@mui/material";

// 2 columns x 3 rows -- matches the "rows x columns" convention used for
// this app's grouped-grid labels (e.g. "3 x 2").
export const ThreeByTwoGridIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="2" y="2" width="9" height="6" rx="1.5" />
    <rect x="13" y="2" width="9" height="6" rx="1.5" />
    <rect x="2" y="9" width="9" height="6" rx="1.5" />
    <rect x="13" y="9" width="9" height="6" rx="1.5" />
    <rect x="2" y="16" width="9" height="6" rx="1.5" />
    <rect x="13" y="16" width="9" height="6" rx="1.5" />
  </svg>
);
